document.querySelectorAll('[data-ls-shape-rail]').forEach((section) => {
  const rail = section.querySelector('.le-seven-shapes__rail');
  const previous = section.querySelector('[data-ls-shape-prev]');
  const next = section.querySelector('[data-ls-shape-next]');
  if (!rail || !previous || !next) return;
  const update = () => {
    previous.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  };
  previous.addEventListener('click', () => rail.scrollBy({left: -rail.clientWidth * .8, behavior: 'smooth'}));
  next.addEventListener('click', () => rail.scrollBy({left: rail.clientWidth * .8, behavior: 'smooth'}));
  rail.addEventListener('scroll', update, {passive: true});
  window.addEventListener('resize', update, {passive: true});
  update();
});
